import type { IconName } from '@fortawesome/fontawesome-svg-core';
import { useTheme } from '@mui/material/styles';
import type { PaletteColor } from '@mui/material/styles';
import React from 'react';

import Icon from '@components/Icon/Icon';

import type { SnackbarVariant } from '@contexts/snackbar';

import {
  CloseDiv,
  IconDiv,
  OuterSnackbar,
  Text,
  TextDiv,
} from './Snackbar.style';

export default function Snackbar({
  message = '',
  variant = 'warning',
  onClick,
}: {
  message?: React.ReactNode;
  variant?: SnackbarVariant;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
}) {
  const { palette } = useTheme();
  let baseColor: PaletteColor;
  let iconName: IconName;

  switch (variant) {
    case 'error':
      baseColor = palette.error;
      iconName = 'circle-xmark';
      break;

    case 'info':
      baseColor = palette.info;
      iconName = 'circle-info';
      break;

    case 'success':
      baseColor = palette.success;
      iconName = 'circle-check';
      break;

    case 'warning':
      baseColor = palette.warning;
      iconName = 'triangle-exclamation';
      break;
  }

  function handleClick(event: React.MouseEvent<HTMLDivElement>) {
    if (onClick) {
      onClick(event);
    }
  }
  return (
    <OuterSnackbar
      backgroundColor={baseColor.light}
      color={baseColor.main}
      data-testid="snackbar-outer"
      onClick={handleClick}
    >
      <IconDiv>
        <Icon color={baseColor.main} name={iconName} />
      </IconDiv>
      <TextDiv>
        <Text data-testid="snackbar-message">{message}</Text>
      </TextDiv>
      <CloseDiv>
        <Icon clickable color={baseColor.main} name="xmark" type="fas" />
      </CloseDiv>
    </OuterSnackbar>
  );
}
